'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var linkedListUtils = require('./linked-list-utils.js');

const removeLinkedList = (id, config) => {
    const { format, list, factory } = config;
    const _a = list.items, _b = id, itemToDelete = _a[_b], otherItems = _tslib.__rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    linkedListUtils.assertPresence(id, list.items);
    const isDoubleLinkList = format === 'double';
    const previousId = isDoubleLinkList
        ? itemToDelete.previousId
        : linkedListUtils.findPreviousId(id, list);
    const newHeadId = previousId === null ? itemToDelete.nextId : list.headId;
    const newItems = Object.assign(Object.assign(Object.assign({}, otherItems), (previousId ? {
        [previousId]: Object.assign(Object.assign({}, otherItems[previousId]), { nextId: itemToDelete.nextId }),
    } : {})), (isDoubleLinkList && itemToDelete.nextId ? {
        [itemToDelete.nextId]: Object.assign(Object.assign({}, otherItems[itemToDelete.nextId]), (isDoubleLinkList ? { previousId } : {})),
    } : {}));
    return factory({
        headId: newHeadId,
        items: newItems,
    });
};

exports.removeLinkedList = removeLinkedList;
//# sourceMappingURL=remove-linked-list.js.map
